import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Custom styles for the Select component
const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "480px",
    height: "24px",
    "@media (max-width: 768px)": {
      width: "300px",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    maxHeight: "180px",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "150px",
    overflowY: "auto",
    fontSize: "16px",
  }),
  control: (provided) => ({
    ...provided,
    minHeight: "30px",
    height: "36px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    height: "14px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "8px",
    svg: {
      width: "18px",
      height: "18px",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
    marginBottom: "10px",
    color: "#004999",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "16px",
    marginBottom: "10px",
    color: "#004999",
  }),
  input: (base) => ({
    ...base,
    padding: "0px",
  }),
};

// List of Indian states
const indianStates = [
  { value: "0", labels: { en: "Andhra Pradesh", Hi: "आंध्र प्रदेश", Kn: "ಆಂಧ್ರ ಪ್ರದೇಶ" } },
  { value: "1", labels: { en: "Arunachal Pradesh", Hi: "अरुणाचल प्रदेश", Kn: "ಅರುಣಾಚಲ ಪ್ರದೇಶ" } },
  { value: "2", labels: { en: "Assam", Hi: "असम", Kn: "ಅಸ್ಸಾಂ" } },
  { value: "3", labels: { en: "Bihar", Hi: "बिहार", Kn: "ಬಿಹಾರ್" } },
  { value: "4", labels: { en: "Chhattisgarh", Hi: "छत्तीसगढ़", Kn: "ಛತ್ತೀಸ್‌ಗಢ" } },
  { value: "5", labels: { en: "Goa", Hi: "गोवा", Kn: "ಗೋವಾ" } },
  { value: "6", labels: { en: "Gujarat", Hi: "गुजरात", Kn: "ಗುಜರಾತ್" } },
  { value: "7", labels: { en: "Haryana", Hi: "हरियाणा", Kn: "ಹರಿಯಾನಾ" } },
  { value: "8", labels: { en: "Himachal Pradesh", Hi: "हिमाचल प्रदेश", Kn: "ಹimachal ಪ್ರದೇಶ" } },
  { value: "9", labels: { en: "Jharkhand", Hi: "झारखंड", Kn: "ಝಾರ್ಖಂಡ್" } },
  { value: "10", labels: { en: "Karnataka", Hi: "कर्नाटक", Kn: "ಕರ್ನಾಟಕ" } },
  { value: "11", labels: { en: "Kerala", Hi: "केरल", Kn: "ಕೆರಳ" } },
  { value: "12", labels: { en: "Madhya Pradesh", Hi: "मध्य प्रदेश", Kn: "ಮಧ್ಯ ಪ್ರದೇಶ" } },
  { value: "13", labels: { en: "Maharashtra", Hi: "महाराष्ट्र", Kn: "ಮಹಾರಾಷ್ಟ್ರ" } },
  { value: "14", labels: { en: "Manipur", Hi: "मणिपुर", Kn: "ಮಣಿಪುರ" } },
  { value: "15", labels: { en: "Meghalaya", Hi: "मेघालय", Kn: "ಮೆಘಾಲಯ" } },
  { value: "16", labels: { en: "Mizoram", Hi: "मिज़ोरम", Kn: "ಮಿಜೋರಾಂ" } },
  { value: "17", labels: { en: "Nagaland", Hi: "नागालैंड", Kn: "ನಾಗಾಲ್ಯಾಂಡ್" } },
  { value: "18", labels: { en: "Odisha", Hi: "ओडिशा", Kn: "ಒಡಿಶಾ" } },
  { value: "19", labels: { en: "Punjab", Hi: "पंजाब", Kn: "ಪಂಜಾಬ್" } },
  { value: "20", labels: { en: "Rajasthan", Hi: "राजस्थान", Kn: "ರಾಜಸ್ಥಾನ್" } },
  { value: "21", labels: { en: "Sikkim", Hi: "सिक्किम", Kn: "ಸಿಕ್ಕಿಂ" } },
  { value: "22", labels: { en: "Tamil Nadu", Hi: "तमिलनाडु", Kn: "ತಮಿಳುನಾಡು" } },
  { value: "23", labels: { en: "Telangana", Hi: "तेलंगाना", Kn: "ತೆಲಂಗಾಣ" } },
  { value: "24", labels: { en: "Tripura", Hi: "त्रिपुरा", Kn: "ತ್ರಿಪುರ" } },
  { value: "25", labels: { en: "Uttar Pradesh", Hi: "उत्तर प्रदेश", Kn: "ಉತ್ತರ ಪ್ರದೇಶ" } },
  { value: "26", labels: { en: "Uttarakhand", Hi: "उत्तराखंड", Kn: "ಉತ್ತರಾಖಂಡ" } },
  { value: "27", labels: { en: "West Bengal", Hi: "पश्चिम बंगाल", Kn: "ಪಶ್ಚಿಮ ಬಂಗಾಳ" } },
];


// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Jurisdictional Police Station",
    stateLabel: "State",
    districtLabel: "District",
    policeStationLabel: "Police Station",
    required: "*",
    errorDistrict: "Please select the district.",
    errorPoliceStation: "Please select the police station.",
    ok: "OK",
    // typeSearchPlaceholder: "Type to search...",
    typeSearchPlaceholder: "search...",
    moveError:"Please answer the current question before proceeding to the next one.",

  },
  Hi: {
    header: "अधिकार क्षेत्रीय पुलिस स्टेशन",
    stateLabel: "राज्य",
    districtLabel: "ज़िला",
    policeStationLabel: "पुलिस स्टेशन",
    required: "*",
    errorDistrict: "कृपया ज़िला चुनें।",
    errorPoliceStation: "कृपया पुलिस स्टेशन चुनें।",
    ok: "ठीक है",
    typeSearchPlaceholder: "करें...",
    moveError:"कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",

    //typeSearchPlaceholder: "खोज के लिए टाइप करें...",
  },
  Kn: {
    header: "ನೀವು ವಾಸಿಸುವ ಸ್ಥಳದಲ್ಲಿರುವ ಹತ್ತಿರದ ಪೊಲೀಸ್ ಠಾಣೆ.",
    stateLabel: "ರಾಜ್ಯ",
    districtLabel: "ಜಿಲ್ಲೆ",
    policeStationLabel: "ಪೊಲೀಸ್ ಠಾಣೆ ಅಯ್ಕೆಮಾಡಿ",
    required: "*",
    errorDistrict: "ಜಿಲ್ಲೆ ಆಯ್ಕೆಮಾಡಿ.",
    errorPoliceStation: "ಪೊಲೀಸ್ ಠಾಣೆ ಅಯ್ಕೆಮಾಡಿ",
    ok: "ಸರಿ",
    typeSearchPlaceholder: "ಅಯ್ಕೆಮಾಡಿ...",
    //typeSearchPlaceholder: "ಹುಡುಕಲು ಟೈಪ್ ಮಾಡಿ...",
    moveError:"ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",

  },
};

const PoliceStation = ({
  onNext,
  onVictimAddressSelected,
  onQuestion,
  apiKey,
  answer,
  botToken,
  vist_id,
  app_ver,
  selectedLang
}) => {
  const [address, setAddress] = useState({
    state: { value: "10", label: "Karnataka" },
    district: null,
    zip: "",
    policeStation: null,
  });
  const [error, setError] = useState("");
  const [districtOptions, setDistrictOptions] = useState([]);
  const [psOptions, setPsOptions] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [rawAddressData, setRawAddressData] = useState(null);
  const [rawPsData, setRawPsData] = useState(null);
  //const [rawPsData, setRawPsData] = useState(null);

  const audioRef = useRef(null);

  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/policestation.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio11.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio11.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };



  // When the selected language changes, update the audio element's source automatically
  useEffect(() => {
    if (audioRef.current) {
      // Update the audio source and reload the element
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      // If audio was playing, continue playing the new audio
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  useEffect(() => {
    const storedDistrict = localStorage.getItem("policeStations");
    if (storedDistrict) {
      const data = JSON.parse(storedDistrict);
      onVictimAddressSelected(data);
      setAddress((prev) => ({
        ...prev, 
        district: data.district || "",
        policeStation: data.policeStation || "",
      }));
      if(data?.district){
        fetchPsData(data?.district?.value);
      }
    }

    
  }, []);

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };


    const getAddressList = (resp, language) => {
      switch (language) {
        case "en":
          return resp.lang_eng;
        case "Hi":
          return resp.lang_hin;
        case "Kn":
          return resp.lang_kanada;
        default:
          return resp.lang_eng; // fallback
      }
    };
  
  
    useEffect(() => {
      if (rawAddressData) {
        const districtList = getAddressList(rawAddressData, selectedLang) || [];
        setDistrictOptions(
          districtList.map((address, index) => ({
            id: String.fromCharCode(65 + index),
            value: address.dist_uniq,
            label: address.dist_nm,
          })) || []
        );
      }
    }, [selectedLang, rawAddressData]);

      useEffect(() => {
        if (rawPsData) {
          const ProfessionList = getAddressList(rawPsData, selectedLang) || [];
          setPsOptions(
            ProfessionList.map((profession, index) => ({
              id: String.fromCharCode(65 + index),
              value: profession.aplps_uni,
              label: profession.aplps_nm,
            })) || []
          );
        }
      }, [selectedLang, rawPsData]);

  useEffect(() => {
    const fetchAddressData = async () => {
      try {
        const qualificationResponse = await fetch(
          `${apiUrl}/v1/cy_ma_districts_list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f65376898d6",
              lac_token: botToken,
              app_ver: app_ver,
              bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
            }),
          }
        );

        if (!qualificationResponse.ok) {
          throw new Error("Failed to fetch Address options");
        }

        const qualificationData = await qualificationResponse.json();
        setRawAddressData(qualificationData.resp);
        // setPoliceOptions(
        //   qualificationData.resp.districts_list.map((address) => ({
        //     value: address.dist_uniq,
        //     label: address.dist_nm,
        //   })) || []
        // );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAddressData();
  }, [apiKey, app_ver, botToken, vist_id]);

  const fetchPsData = async (districtValue) => {
    try {
      const qualificationResponse = await fetch(
        `${apiUrl}/v1/cy_ma_applicable_ps_list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: apiKey,
            dst: districtValue,
            visitor_token: vist_id,
            qtion_id: "66f65376898d6",
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        }
      );

      if (!qualificationResponse.ok) {
        throw new Error("Failed to fetch police station options");
      }

      const psData = await qualificationResponse.json();
      setRawPsData(psData.resp); 
      // setPsOptions(
      //   qualificationData.resp.lang_eng.map((ps) => ({
      //     value: ps.aplps_uni,
      //     label: ps.aplps_nm,
      //   })) || []
      // );
      // setPsOptions(
      //   qualificationData.resp.ps_list.map((ps) => ({
      //     value: ps.aplps_uni,
      //     label: ps.aplps_nm,
      //   })) || []
      // );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleStateChange = (selectedOption) => {
    setAddress((prevState) => ({
      ...prevState,
      state: selectedOption,
      district: null, // Reset district when state changes
    }));
    setError("");
  };

  const handleDistrictChange = (selectedOption) => {
    setAddress((prevState) => ({
      ...prevState,
      district: selectedOption,
      policeStation: undefined,
    }));
    fetchPsData(selectedOption.value);
    localStorage.removeItem("policeStations");
    setError("");
  };

  const handlePoliceChange = (selectedOption) => {
    setAddress((prevState) => ({
      ...prevState,
      policeStation: selectedOption,
    }));
    setError("");
  };

  const handleOkClick = async (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    if (!address.district) {
      setError('errorDistrict');
      return;
    }
    if (!address.policeStation) {
      setError('errorPoliceStation');
      return;
    }

    const dataToSubmit = {
      api_key: apiKey,
      visitor_token: vist_id,
      qtion_id: "67064ae25a10a798740151",
      qtion_num: "9",
      district: address.district ? address.district.value : null,
      ps: address.policeStation ? address.policeStation.value : null,
      lac_token: botToken,
      app_ver: app_ver,
      bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
    };
 
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_ps`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        throw new Error("Failed to save address");
      }

      const data = await response.json();
      if (data.resp.error_code === "0") {
        localStorage.setItem("policeStations", JSON.stringify(address));
        onVictimAddressSelected(address);
        onNext(11);
        onQuestion(12);
        setError("");
      } else {
        setError("Failed to push data to API");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setError("Failed to save address data");
    }
  };


  const getIndianStatesOptions = (lang) =>
    indianStates.map((state) => ({
      value: state.value,
      label: state.labels[lang] || state.labels.en,
    }));
  return (
    <div className="question">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex" }}>
              <h2>
                {translations[selectedLang].header}{" "}
                <span style={{ color: "red" }}>
                  {translations[selectedLang].required}
                </span>
              </h2>
              <button onClick={toggleAudio} className="audio-button">
                {isPlaying ? (
                  <FaPause color="White" size={12} style={{ marginBottom: '20px' }}/>
                ) : (
                  <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>
                )}
              </button>
            </div>
            <audio ref={audioRef} onEnded={handleAudioEnd}>
              <source src={audioMap[selectedLang]} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
            <div>
              <h6 style={{ margin: "5px", marginTop: "20px" }} htmlFor="state">
                {translations[selectedLang].stateLabel}
              </h6>
              <Select
                 options={getIndianStatesOptions(selectedLang)}
                 value={getIndianStatesOptions(selectedLang).find(option => option.value === "10")}
                onChange={handleStateChange}
                id="state"
                styles={customStyles}
                isDisabled={true}
              />
              <h6 style={{ margin: "5px", marginTop: "20px" }} htmlFor="district">
                {translations[selectedLang].districtLabel}
                <span style={{ color: "red" }}>
                  {translations[selectedLang].required}
                </span>
              </h6>
              <Select
                options={districtOptions}
                value={districtOptions?.find(option => option.value === address.district?.value) || null}
                onChange={handleDistrictChange}
                id="district"
                styles={customStyles}
                placeholder={translations[selectedLang].typeSearchPlaceholder}
              />
              <h6
                style={{ margin: "5px", marginTop: "20px" }}
                htmlFor="policeStation"
              >
                {translations[selectedLang].policeStationLabel}
                <span style={{ color: "red" }}>
                  {translations[selectedLang].required}
                </span>
              </h6>
              <div className="select-container">
                <Select
                  id="policeStation"
                  value={psOptions?.find(option => option.value === address.policeStation?.value) || null}
                  onChange={handlePoliceChange}
                  options={psOptions}
                  placeholder={translations[selectedLang].typeSearchPlaceholder}
                  aria-label="Police Station"
                  className="dropdown-input"
                  styles={customStyles}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "10px",
                position: "relative",
                zIndex: "9",
              }}
            >
              <button type="button" className="ok-btn" onClick={handleOkClick}>
                {translations[selectedLang].ok}
              </button>
            </div>
            {error && (
              <p
                style={{
                  color: "red",
                  marginTop: "10px",
                  position: "relative",
                  zIndex: "1000",
                }}
              >
                {translations[selectedLang][error]}
              </p>
            )}
            {answer[10] && (
              <p className="alert-box">
{translations[selectedLang].moveError}              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliceStation;
